module.exports = __webpack_public_path__ + "static/media/CYT.77985624.png";